// 请求业务 code

// 需要特殊处理的 业务错误code
export enum BizErrorCode {
  NEED_ROOM_CHECK = 12050, // 查房未完成
  ROOM_CARD_NEED_FETCH_BACK = 12051, // 退房卡未完成
  APPLY_CANCELED = 54020, // 该预订已被用户取消，无法下单
  PMS_CANCELED = 54021, // 该预订已被取消，无法下单
  RESERVE_ORDER_CANCELED = 12076, // 取消已下单预订订单时该订单已被取消
  CRS_ORDER_CANCELED = 54009, // 取消CRS预订订单时该订单已被取消
  DEV_CERT_NO_ERROR = 101920012, // dev环境证件号码查询错误
  PROD_CERT_NO_ERROR = 102020011, // prod环境证件号码查询错误
  VIP_CARD_MG_ERROR = 101910000, // 扫码获取会员信息中台异常
  VIP_CARD_ERROR = 11019, // 扫码获取会员信息错误
  REV_SETTLE_ERROR = 14078, // 反结账失败（结账单不允许反结账）
  REV_SETTLE_CRS_ERROR = 14079, // 反结账失败（结账单包含CRS预付款、OTA预付款）
  REFUND_AMOUNT_ERROR = 14068, // 退款失败(可退金额不足)
  CROSS_REFUND_BILL_STATUS_ERROR = 14086, // 跨夜审退款必须是已结账的账单
  CROSS_REFUND_BILL_RANGE_ERROR = 14087, // 请等待当前账期结束再进行跨夜审退款

  COUPON_THRESHOLD_CALCULATE = 11037, // 用券门槛金额计算错误
  EMPLOYEE_DINGTALK_INVITE = 54101, // 重发钉钉邀请
}

// 不清楚接口 而特殊处理的 业务错误code （eg: 排房失败）
export enum SpecialErrorCode {
  AUTO_ROOM_ASSIGN_ERROR = 12030, // 自动排房失败，无可排房间
  ROOM_PREASSIGN_FAIL = 12046, // 排房失败
  ALL_ROOM_OCCUPY_ROOM_TYPE = 12134, // 排房失败 msg 放回房型信息 房型：%s
  FEE_SUBMIT_LIMIT = 51021, // 费用列表-费用提报 提报次数受限制提醒
  DY_OFFLINE_FAIL = 54420, // 抖音下架失败-抖音预售产品已被关联预售券
}
